import { FORM_CATEGORIES } from '../../../../../utils/constants.js';
import type { CustomStepTemplate } from './TemplateSelector.types.ts';

const DEFAULT_DISCHARGE_LETTER_UPLOAD_TITLE = 'Upload Your Discharge Letter';
const DEFAULT_DISCHARGE_LETTER_UPLOAD_DESCRIPTION = ({ healthCategoryId }: { healthCategoryId: string }) =>
  `You can only have one ${healthCategoryId} prescriber at a time. Before we can consider prescribing, please ask your previous prescriber for a discharge letter and upload it here when you have it`;

const DISCHARGE_LETTER_TEMPLATES: CustomStepTemplate<'DISCHARGE_LETTER_UPLOAD'>[] = [
  {
    id: 'discharge-letter',
    type: 'DISCHARGE_LETTER_UPLOAD',
    healthCategories: [FORM_CATEGORIES.MEDICINAL_CANNABIS],

    getData: ({ healthCategoryId }) => ({
      name: 'Discharge Letter Upload',
      description: `Request patient to upload discharge letter from previous prescriber for ${healthCategoryId}`,
      stepData: {
        title: DEFAULT_DISCHARGE_LETTER_UPLOAD_TITLE,
        description: DEFAULT_DISCHARGE_LETTER_UPLOAD_DESCRIPTION({ healthCategoryId }),
        metadata: {},
      },
    }),
  },
];

export const templates = [...DISCHARGE_LETTER_TEMPLATES] as CustomStepTemplate[];
